import type { Ref } from "vue";
import { watch } from "vue";

import type { LayoutBarId } from "@/store/layoutStore";
import { useLayoutStore } from "@/store/layoutStore";

export default function useResponsiveBarVisibility(
  barId: LayoutBarId,
  fits: Readonly<Ref<boolean>>,
  isApplicable: () => boolean = () => true,
) {
  const layoutStore = useLayoutStore();
  let wasVisibleBeforeCollapse = false;

  watch(fits, (nowFits) => {
    if (!isApplicable()) return;

    if (!nowFits) {
      wasVisibleBeforeCollapse = layoutStore.bars[barId].visible;
      layoutStore.setBarVisibility(barId, false);
    } else if (wasVisibleBeforeCollapse) {
      layoutStore.setBarVisibility(barId, true);
      wasVisibleBeforeCollapse = false;
    }
  });
}
